<template>
  <component :is="layout">
    <RouterView/>
    <ReloadPrompt/>
  </component>
</template>

<script setup lang="ts">
import { onMounted, computed, watch } from 'vue';
import {RouterView, useRoute} from 'vue-router'
import {type IStaticMethods} from "preline/preline";

import PublicLayout from '@/layouts/PublicLayout.vue';
import PrivateLayout from '@/layouts/PrivateLayout.vue';
import ReloadPrompt from "@/components/ui/ReloadPrompt.vue";
import {initPushSubscription} from "@/services/push-service";
import {useAppComposable} from "@/composables/useAppComposable";

const {
  isValidUser
} = useAppComposable();

const route = useRoute();

// Dynamically select layout based on route meta
const layout = computed(() => {
  return route.meta.layout === 'private' ? PrivateLayout : PublicLayout;
});

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}

onMounted(() => {
  log.debug("App mounted, initializing...");
  setTimeout(() => {
    window.HSStaticMethods.autoInit();
  }, 100)
});

watch(isValidUser, (newVal) => {
  if (newVal) {
    setTimeout(() => {
      initPushSubscription();
    }, 5000);
  }
}, { immediate: true });
</script>
